import {
  UpdateUserStatusPayload,
  UserStatusInterface,
  userStatusApiHandler,
} from '@api/userStatusApiHandler';
import { ApiResponse } from '@interfaces/index';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getUserStatusData } from 'store/Actions/UserStatusAction';
import { useAppDispatch } from './useAppDispatch';

export const useUpdateUserStatus = (refetchStatuses: boolean) => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  return useMutation<ApiResponse<UserStatusInterface>, Error, Partial<UpdateUserStatusPayload>>({
    mutationFn: userStatusApiHandler.updateUserStatus,
    onSuccess: async () => {
      if (refetchStatuses) {
        await dispatch(getUserStatusData());
      }

      // queryClient.invalidateQueries({ queryKey: ['userStatus'] }); // Refetch user status after update
    },
  });
};
